<template>
  <v-dialog
    v-model="localDialog"
    width="40%"
    persistent
    @update:modelValue="updateDialog"
  >
    <v-card>

      <v-card-title class="text-h6">
        <span>{{ isEntryMode ? 'Add SubModule' : 'Update SubModule' }}</span>
      </v-card-title>

      <v-divider />

      <v-card-text>

        <v-form @submit.prevent="submit">

          <v-row>
            <v-col cols="12">

              <!-- MODULE -->
              <v-autocomplete
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                v-model="module_id.value.value"
                :items="getModuleList.filter(item => item.status == 1)"
                :item-title="item => item?.name && item?.code ? `${item.name} - ${item.code}` : ''"
                item-value="id"
                :error-messages="module_id.errorMessage.value"
                clearable
              
                  :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                <template #label>
                  Module <span class="text-red-accent-4">*</span>
                </template>
              </v-autocomplete>

              <!-- NAME -->
              <v-text-field
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="name.value.value"
                :error-messages="name.errorMessage.value"
                clearable
              >
                <template #label>
                  Name <span class="text-red-accent-4">*</span>
                </template>
              </v-text-field>

              <!-- SL -->
              <v-text-field
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="sl.value.value"
                :error-messages="sl.errorMessage.value"
                clearable
              >
                <template #label>
                  Serial <span class="text-red-accent-4">*</span>
                </template>
              </v-text-field>

              <!-- ICON -->
              <v-text-field
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="icon.value.value"
                :error-messages="icon.errorMessage.value"
                clearable
              >
                <template #label>
                  Icon <span class="text-red-accent-4">*</span>
                </template>
              </v-text-field>

              <!-- CHECKBOXES -->
              <v-card-actions>
                <v-row class="px-4">

                  <v-col cols="6">
                    <v-checkbox
                      label="Active"
                      v-model="status.value.value"
                      :true-value="1"
                      :false-value="0"
                      density="compact"
                      color="primary"
                      hide-details
                    />
                  </v-col>

                  <v-col cols="6">
                    <v-checkbox
                      label="Is App"
                      v-model="is_app.value.value"
                      :true-value="1"
                      :false-value="0"
                      density="compact"
                      color="primary"
                      hide-details
                    />
                  </v-col>

                </v-row>
              </v-card-actions>

              <input type="hidden" v-model="submodule_id.value.value" />

            </v-col>
          </v-row>

          <v-divider />

          <v-card-actions>
            <v-layout class="justify-end">

              <v-btn class="bg-red" variant="flat" @click="closeDialog">
                Close
              </v-btn>

              <v-btn class="bg-brand ms-2" variant="flat" type="submit">
                {{ isEntryMode ? 'Save' : 'Update' }}
              </v-btn>

            </v-layout>
          </v-card-actions>

        </v-form>

      </v-card-text>

    </v-card>
  </v-dialog>
</template>

<script>
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { toast } from 'vue3-toastify'

export default {
  name: 'ModuleSetup',

  props: {
    dialog: Boolean,
    data: {
      type: Object,
      default: () => ({
        name: '',
        icon: '',
        sl: '',
        status: 1,
        is_app: 1,
        module_id: null,
        id: null
      })
    }
  },

  data() {
    return {
      localDialog: this.dialog,
      isEntryMode: true
    }
  },

  computed: {
    getModuleList() {
      return this.$store.getters.getModuleList
    }
  },

  watch: {

    dialog(val) {
      this.localDialog = val

      // 🔥 RESET ON ADD OPEN
      if (val && !this.data?.id) {
        this.isEntryMode = true

        this.name.setValue('', false)
        this.icon.setValue('', false)
        this.sl.setValue('', false)
        this.module_id.setValue(null, false)
        this.submodule_id.setValue(null, false)
        this.status.setValue(1, false)
        this.is_app.setValue(1, false)

        this.resetForm()
      }
    },

    localDialog(val) {
      this.$emit('update:dialog', val)
    },

    data: {
      handler(newData) {

        if (!newData) return

        this.isEntryMode = !newData.id

        this.name.setValue(newData.name || '', false)
        this.icon.setValue(newData.icon || '', false)
        this.sl.setValue(newData.sl || '', false)
        this.module_id.setValue(newData.module_id || null, false)
        this.submodule_id.setValue(newData.id || null, false)

        this.status.setValue(
          newData.status !== undefined ? Number(newData.status) : 1,
          false
        )

        this.is_app.setValue(
          newData.is_app !== undefined ? Number(newData.is_app) : 1,
          false
        )
      },
      deep: true,
      immediate: true
    }
  },

  created() {
    // if (this.$store.getters.getModuleList.length === 0) {
      this.$store.dispatch('getModuleList')
    // }
  },

  methods: {
    updateDialog(val) {
      this.$emit('update:dialog', val)
    },

    closeDialog() {
      this.resetForm()
      this.$emit('update:dialog', false)
    }
  },

  setup(props, { emit }) {

    const store = useStore()

    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        name: yup.string().required(),
        icon: yup.string().required(),
        sl: yup.number().required(),
        module_id: yup.number().required(),
        submodule_id: yup.number().nullable()
      })
    })

    const name = useField('name')
    const icon = useField('icon')
    const sl = useField('sl')
    const status = useField('status')
    const is_app = useField('is_app')
    const module_id = useField('module_id')
    const submodule_id = useField('submodule_id')

    const submit = handleSubmit(async (values) => {
      try {

        await store.dispatch('saveUpdateSubModuleSetup', values)

        toast.success('Success')

        resetForm()
        emit('update:dialog', false)

        store.dispatch('getSubModuleList')

      } catch (e) {
        toast.error(e?.response?.data?.message || 'Error')
      }
    })

    return {
      submit,
      resetForm,

      name,
      icon,
      sl,
      status,
      is_app,
      module_id,
      submodule_id
    }
  }
}
</script>